<script setup lang="ts">
import { useContactRequestForm } from '@b2b-platform/commerce/composables/useContactRequestForm';

const { isOpen, open } = useContactRequestForm();
</script>

<template>
    <section
        id="contact-request"
        class="mt-11 bg-green-400 lg:mt-12"
        style="content-visibility: auto"
    >
        <CommBaseContentContainer
            class="flex flex-col-reverse items-center gap-10 py-8 md:flex-row md:items-start md:justify-between md:gap-6 md:!px-20 md:!py-12"
        >
            <div
                class="flex flex-col items-center gap-6 text-center md:items-start md:text-left lg:text-left"
            >
                <h2 class="flex flex-col">
                    <BaseHeading as="span" variant="xl-500">
                        Gemeinsam finden wir
                    </BaseHeading>
                    <BaseHeading as="span" variant="xl-400">
                        die passende Lösung.
                    </BaseHeading>
                </h2>

                <div
                    class="w-full"
                    :class="{ 'invisible ': !isOpen }"
                    :style="`display:grid;grid-template-rows:${
                        isOpen ? '1fr' : '0fr'
                    };transition:grid-template-rows 640ms cubic-bezier(0.77,0,0.18,1);`"
                >
                    <CommContactRequestForm
                        tracking-method="General"
                        variant="light"
                    />
                </div>

                <Transition>
                    <JamBaseButton
                        v-if="!isOpen"
                        class="w-full text-center md:w-fit"
                        variant="gray"
                        @click="open"
                    >
                        Jetzt kontaktieren
                    </JamBaseButton>
                </Transition>
            </div>
            <NuxtImg
                src="/illustrations/basic-conversation.svg"
                loading="lazy"
                decoding="auto"
                alt=""
                class="w-[160px] md:w-[250px]"
            />
        </CommBaseContentContainer>
    </section>
</template>
